<template>
    <div class="page-content header-clear-medium">

		<div class="card card-style">
			<div class="content">

				<h3 class="text-center mb-3 color-blue-dark">Input Data Tatib</h3>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<i class="bi bi-calendar font-12"></i>
						<input type="date" v-model="dataStore.date" :disabled="storeProcessTatib" class="form-control rounded-xs" id="c5">
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<!-- <i class="bi bi-sliders font-13"></i> -->
						<i class="bi bi-list-ol font-13"></i>
						<select v-model="filterParams.kelas_id" :disabled="storeProcessTatib" @change="onChangeFilterTingkat" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
							<option value="" selected="">- Pilih Tingkat -</option>
							<option v-for="item in tingkats" :key="item.id" :value="item.id">{{ item.nama }}</option>
						</select>
						<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<!-- <i class="bi bi-sliders font-13"></i> -->
						<i class="bi bi-bookmarks-fill font-13"></i>
						<select v-model="filterParams.rombel_id" :disabled="storeProcessTatib" @change="onChangeFilterRombel" class="form-select rounded-xs" id="c7" aria-label="Floating label select example">
							<option value="" selected="">- Pilih Kelas -</option>
							<option v-for="item in rombels" :key="item.id" :value="item.id">{{ item.nama }}</option>
						</select>
						<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>
				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<!-- <i class="bi bi-sliders font-13"></i> -->
						<i class="bi bi-person-circle font-13"></i>
						<select v-model="dataStore.student_id" :disabled="storeProcessTatib" @change="onChangeFilterStudent" class="form-select rounded-xs" id="c8" aria-label="Floating label select example">
							<option value="" selected="">- Pilih Siswa -</option>
							<option v-for="item in students" :key="item.id" :value="item.id">{{ item.nama }}</option>
						</select>
						<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<!-- <div v-if="student_selected" class="list-group list-custom list-group-m rounded-m list-group-flush pe-2">
					<span class="list-group-item">
						<img :src="preloadImageDummy" :data-src="student_image" width="40" class="preload-img me-2 rounded-circle">
						<div class="ps-1"><strong class="font-600">{{ studentSelectedData.nama }}</strong><span>{{ studentSelectedData.nisn }}</span></div>
						<span class="badge rounded bg-blue-dark font-12">{{ studentKelasRombel }}</span>
					</span>
				</div> -->
				<div v-if="student_selected" class="d-flex mb-3">
					<div class="align-self-top me-1">
						<img :src="preloadImageDummy" :data-src="student_image" width="40" class="preload-img me-2 rounded-circle">
					</div>
					<div class="d-sm-flex justify-content-sm-between w-100">
						<div class="font-14" style="color: #212529;">
							<strong class="font-600">{{ studentSelectedData.nama }}</strong>
							<span class="d-block" style="opacity: 0.4; line-height: 1;">{{ studentSelectedData.nisn }}</span>
						</div>
						<div>
							<span class="badge rounded bg-blue-dark font-12">{{ studentKelasRombel }}</span>
						</div>
					</div>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<!-- <i class="bi bi-sliders font-13"></i> -->
						<i class="bi bi-list-ol font-13"></i>
						<select v-model="filterParams.type_id" :disabled="storeProcessTatib" @change="onChangeFilterTatibTypes" class="form-select rounded-xs" id="c11" aria-label="Floating label select example">
							<option value="" selected="">- Pilih Jenis Pelanggaran -</option>
							<option v-for="item in tatib_types" :key="item.id" :value="item.id">{{ item.name }}</option>
						</select>
						<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<!-- <i class="bi bi-sliders font-13"></i> -->
						<i class="bi bi-list-ol font-13"></i>
						<select v-model="filterParams.chapter_id" :disabled="storeProcessTatib" @change="onChangeFilterTatibChapter" class="form-select rounded-xs" id="c12" aria-label="Floating label select example">
							<option value="" selected="">- Pilih Pasal -</option>
							<option v-for="item in chapters" :key="item.id" :value="item.id">{{ item.name }}</option>
						</select>
						<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<!-- <i class="bi bi-sliders font-13"></i> -->
						<i class="bi bi-list-ol font-13"></i>
						<select v-model="dataStore.clause_id" :disabled="storeProcessTatib" @change="onChangeFilterTatibClause" class="form-select rounded-xs" id="c13" aria-label="Floating label select example">
							<option value="" selected="">- Pilih Ayat -</option>
							<option v-for="item in clauses" :key="item.id" :value="item.id">{{ item.content }}</option>
						</select>
						<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<div v-if="chapter_selected" class="rounded border border-teal-light p-2">
					<p class="mb-0"><mark class="highlight ps-2 pe-2 bg-red-dark">Pasal</mark> : {{ chapterSelectedData.name }}</p>
					<p class="mb-1">{{ chapterSelectedData.description }}</p>
					<p v-if="clause_selected"><mark class="highlight ps-2 pe-2 bg-red-dark">Ayat</mark> : {{ clauseSelectedData.content }}</p>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<i class="bi bi-pencil-fill font-12"></i>
						<textarea v-model="dataStore.description" :disabled="storeProcessTatib" class="form-control rounded-xs" placeholder="Keterangan (Merokok)" id="c9"></textarea>
						<label for="c9" class="color-theme">Keterangan</label>
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<div class="col-12 pe-0">
					<div class="form-custom form-label form-icon mb-2">
						<i class="bi bi-pencil-fill font-12"></i>
						<textarea v-model="dataStore.action" :disabled="storeProcessTatib" class="form-control rounded-xs" placeholder="Tindakan" id="c10"></textarea>
						<label for="c10" class="color-theme">Tindakan</label>
						<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
					</div>
				</div>

				<button @click="onStoreTatibData" :disabled="storeProcessTatib" class="btn bg-green-dark rounded-xs text-uppercase font-700 w-100 btn-s mt-4">Simpan</button>

			</div>

		</div>
        
    </div>
</template>

<script>
import { 
	// mapMutations, 
	mapActions, mapState 
} from 'vuex'

import moment from 'moment'

export default {
    name: 'TatibData',
    components: {
		// ReportFilter, 
    },
    data() {
        return {
			filterParams: {
				kelas_id: '',
				rombel_id: '',
				type_id: '',
				chapter_id: '',
			},
			preloadImageDummy: require('@/assets/image-dummy/no-profil-image.png'),
			student_image: '',
			studentKelasRombel: '',
			dataStore : {
				type: 'student',
				date: moment().format('YYYY-MM-DD'),
				student_id: '',
				description: '',
				action: '',
				clause_id: '',
			},
			rombels: [],
            students: [],
			student_selected: false,
			studentSelectedData: {},
			chapters: [],
			chapter_selected: false,
			chapterSelectedData: {},
			clauses: [],
			clause_selected: false,
			clauseSelectedData: {},
			storeProcessTatib: false,
        }
    },
    async created() {
		// this.SET_LOADING()
        // await this.getHomepagePost()
		// await this.getStudentMe()
		// this.CLEAR_LOADING()
		await this.getTingkat()
		await this.getTatibTypes()
    },
	mounted() {
		// this.$nextTick(function () {
		// 	// do stuff with the DOM
		// 	document.refreshSlider()
		// })
	},
	updated() {
		// this.$nextTick(function () {
		// 	// do stuff with the DOM
		// 	document.refreshSlider()
		// })
	},
    methods: {
        // ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
		...mapActions('data', ['getTingkat', 'getRombel', 'getStudents']),
		...mapActions('tatib', ['getTatibTypes', 'getTatibChapters', 'getTatibClauses', 'storeTatibData']),
		async onChangeFilterTingkat() {
            if (this.filterParams.kelas_id == '') {
                this.rombels = []
                this.filterParams.rombel_id = ''
            } else {
                let responseGetRombel = await this.getRombel(this.filterParams.kelas_id)
                this.rombels = responseGetRombel.data
            }

            this.students = []

			this.student_selected = false
			this.studentSelectedData = {}
			this.student_image = ''
			this.dataStore.student_id = ''
        },
		async onChangeFilterRombel() {
            if (this.filterParams.rombel_id == '') {
                this.students = []
            } else {
                let responseGetStudents = await this.getStudents(this.filterParams.rombel_id)
                this.students = responseGetStudents.data
            }

			this.student_selected = false
			this.studentSelectedData = {}
			this.student_image = ''
			this.dataStore.student_id = ''
        },
        async onChangeFilterStudent() {
			if (this.dataStore.student_id == '') {
				this.student_selected = false
				this.studentSelectedData = {}
				this.student_image = ''
			}

			this.students.forEach(item => {
				if (item.id == this.dataStore.student_id) {
					this.student_selected = true
					this.studentSelectedData = item
					this.student_image = item.url_photo
				}
			})

			let tempStudentKelasRombel = ''
			this.tingkats.forEach(item => {
				if (item.id == this.filterParams.kelas_id) tempStudentKelasRombel = item.nama
			})
			this.rombels.forEach(item => {
				if (item.id == this.filterParams.rombel_id) tempStudentKelasRombel += ' '+item.nama
			})
			this.studentKelasRombel = tempStudentKelasRombel
        },
		async onChangeFilterTatibTypes() {
            if (this.filterParams.type_id == '') {
                this.chapters = []
                this.filterParams.chapter_id = ''
				this.dataStore.clause_id = ''
            } else {
                let responseGetChapters = await this.getTatibChapters(this.filterParams.type_id)
                this.chapters = responseGetChapters.data
            }
			this.clauses = []
        },
		async onChangeFilterTatibChapter() {
			if (this.filterParams.chapter_id == '') {
                this.clauses = []

				this.chapter_selected = false
				this.chapterSelectedData = {}
            } else {
                let responseGetClauses = await this.getTatibClauses(this.filterParams.chapter_id)
                this.clauses = responseGetClauses.data

				this.chapters.forEach(item => {
					if (item.id == this.filterParams.chapter_id) {
						this.chapter_selected = true
						this.chapterSelectedData = item
					}
				})
            }

			this.dataStore.clause_id = ''
			
			this.clause_selected = false
			this.clauseSelectedData = {}
		},
		onChangeFilterTatibClause() {
			if (this.dataStore.clause_id == '') {
				this.clause_selected = false
				this.clauseSelectedData = {}
            } else {
				this.clauses.forEach(item => {
					if (item.id == this.dataStore.clause_id) {
						this.clause_selected = true
						this.clauseSelectedData = item
					}
				})
            }
		},
		async onStoreTatibData() {
			this.storeProcessTatib = true
			try {
				await this.storeTatibData(this.dataStore)
				setTimeout(() => {
					this.$router.replace({name: 'tatib.data'})
				}, 500);
			} catch (error) {
				this.storeProcessTatib = false
			}
		}
    },
    computed: {
        // ...mapState({
        //     loading: state => state.loading
        // }),
		...mapState('data', {
            tingkats: state => state.tingkats
        }),
        ...mapState('tatib', {
            tatib_types: state => state.tatib_types,
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
